import * as React from 'react';
import Affix from '@telia-front/affix';
import Container from '@telia-front/container';
import { default as Grid, GridColumn } from '@telia-front/grid';
import { debounce } from '@telia-front/helper';
import CompareCheck from './compare-check';
import ContentTable from './content-table';
import HeaderTable from './header-table';
import Pager from './pager';
import Title from './title';
export default class MobileComparison extends React.Component {
    constructor(props) {
        super(props);
        this.headerTableRef = null;
        this.headerTableAffixRef = null;
        this.contentRef = React.createRef();
        this.currentSlideIndex = 0;
        this.slideOffset = 0;
        this.scrollContentAfterSlideChange = true;
        this.setHeaderTableRef = (el) => {
            this.headerTableRef = el;
        };
        this.setHeaderTableAffixRef = (el) => {
            this.headerTableAffixRef = el;
        };
        this.handleHeaderTableScroll = () => {
            if (this.contentRef.current && this.headerTableRef && this.headerTableAffixRef && !this.state.isScrolling) {
                this.contentRef.current.scrollLeft = this.headerTableRef.scrollLeft;
                this.headerTableAffixRef.scrollLeft = this.headerTableRef.scrollLeft;
            }
        };
        this.handleHeaderTableAffixScroll = () => {
            if (this.contentRef.current && this.headerTableRef && this.headerTableAffixRef && !this.state.isScrolling) {
                this.contentRef.current.scrollLeft = this.headerTableAffixRef.scrollLeft;
                this.headerTableRef.scrollLeft = this.headerTableAffixRef.scrollLeft;
            }
        };
        this.handleContentScroll = () => {
            if (this.contentRef.current && this.headerTableRef && this.headerTableAffixRef) {
                this.headerTableRef.scrollLeft = this.contentRef.current.scrollLeft;
                this.headerTableAffixRef.scrollLeft = this.contentRef.current.scrollLeft;
                this.scrollContentAfterSlideChange = false;
                this.updateSlide(this.contentRef.current.scrollLeft);
            }
        };
        this.setSlide = (slideIndex) => {
            var _a;
            if (this.currentSlideIndex !== slideIndex) {
                (_a = this.state.pagerSlider) === null || _a === void 0 ? void 0 : _a.slickGoTo(slideIndex);
            }
            this.scrollContentAfterSlideChange = true;
        };
        this.getNextCell = (slide) => {
            if (this.contentRef.current) {
                return this.contentRef.current.querySelector(`table > tbody > tr > td:nth-child(${slide + 2})`);
            }
            return null;
        };
        this.handleSlideChange = (slide) => {
            this.currentSlideIndex = slide;
            if (this.contentRef.current) {
                const cell = this.getNextCell(slide);
                if (cell && this.headerTableRef && this.headerTableAffixRef && this.scrollContentAfterSlideChange) {
                    this.slideOffset = cell.offsetLeft;
                    if (this.state.isScrolling) {
                        this.contentRef.current.addEventListener('scroll', this.scrollCallback);
                    }
                    this.contentRef.current.scroll({
                        left: cell.offsetLeft,
                        behavior: 'smooth',
                    });
                    this.headerTableRef.scroll({
                        left: cell.offsetLeft,
                        behavior: 'smooth',
                    });
                    this.headerTableAffixRef.scroll({
                        left: cell.offsetLeft,
                        behavior: 'smooth',
                    });
                }
            }
        };
        this.isScrolling = () => {
            if (this.contentRef.current) {
                return this.contentRef.current.scrollLeft !== this.slideOffset;
            }
            return false;
        };
        this.scrollCallback = () => {
            const scrollInterval = setInterval(() => {
                if (this.contentRef.current && !this.isScrolling()) {
                    this.setState({
                        isScrolling: false,
                    });
                    this.contentRef.current.removeEventListener('scroll', this.scrollCallback);
                    clearInterval(scrollInterval);
                }
            }, 10);
        };
        this.handleButtonClick = () => {
            this.setState({
                isScrolling: true,
            });
        };
        this.state = {
            pagerSlider: null,
            affixPagerSlider: null,
            isScrolling: false,
        };
        this.debouncedSlideSetter = debounce(this.setSlide, 50);
    }
    updateSlide(scrollPosition) {
        if (this.contentRef.current) {
            const cells = this.contentRef.current.querySelectorAll('table > tbody > tr > td');
            for (const cell of cells) {
                if (cell.offsetLeft + cell.offsetWidth / 2 > scrollPosition) {
                    const nextSlideIndex = cell.cellIndex - 1;
                    this.debouncedSlideSetter(nextSlideIndex);
                    return;
                }
            }
        }
    }
    renderHeader(inAffix = false) {
        const { items, placeholder } = this.props;
        const isDisabled = inAffix ? !this.props.hasScrolled : !!this.props.hasScrolled;
        return (React.createElement("div", { className: "product-comparison__wrapper", ref: !inAffix ? this.props.headerRef : undefined, "aria-hidden": isDisabled },
            React.createElement(Pager, { items: items, nextArrowText: this.props.nextArrowText, prevArrowText: this.props.prevArrowText, sliderRef: (slider) => {
                    if (inAffix) {
                        if (slider && slider !== this.state.affixPagerSlider) {
                            this.setState({
                                affixPagerSlider: slider,
                            });
                        }
                    }
                    else {
                        if (slider && slider !== this.state.pagerSlider) {
                            this.setState({
                                pagerSlider: slider,
                            });
                        }
                    }
                }, placeholder: placeholder, asNavFor: inAffix ? this.state.pagerSlider : this.state.affixPagerSlider, afterChange: !inAffix ? this.handleSlideChange : undefined, onItemClick: this.debouncedSlideSetter, onNextButtonClick: this.handleButtonClick, onPrevButtonClick: this.handleButtonClick }),
            React.createElement(HeaderTable, { deviceLabel: this.props.deviceLabel, placeholder: this.props.placeholder, items: this.props.items, title: this.props.title, compareCheckLabel: this.props.compareCheckLabel, isCompareChecked: this.props.isCompareChecked, onCompareCheckChange: this.props.onCompareCheckChange, isMobile: true, elementRef: inAffix ? this.setHeaderTableAffixRef : this.setHeaderTableRef, onScroll: inAffix ? this.handleHeaderTableAffixScroll : this.handleHeaderTableScroll, isDisabled: isDisabled })));
    }
    renderContent() {
        const { categories, items } = this.props;
        return (React.createElement("div", { className: "product-comparison__content-wrapper", ref: this.contentRef, onScroll: this.handleContentScroll }, categories.map((category) => {
            return (React.createElement(ContentTable, { key: category.id, category: category, label: category.label, deviceLabel: this.props.deviceLabel, items: items, isMobile: true }));
        })));
    }
    render() {
        return (React.createElement(React.Fragment, null,
            React.createElement(Container, { className: "product-comparison__container" },
                React.createElement(Grid, { align: ['between-xs', 'middle-xs'] },
                    React.createElement(GridColumn, { width: ['xs'] },
                        React.createElement(Title, { title: this.props.title, gutter: "small", iconSize: "xs" })),
                    React.createElement(GridColumn, { width: ['xs'] },
                        React.createElement(CompareCheck, { id: "content", onChange: this.props.onCompareCheckChange, checked: this.props.isCompareChecked, disabled: this.props.items.length < 2, labelText: this.props.compareCheckLabel })))),
            React.createElement(Affix, { className: "product-comparison__affix" }, this.renderHeader(true)),
            this.renderHeader(),
            this.renderContent()));
    }
}
